import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { WHATSAPP_PHONE_DISPLAY, WHATSAPP_URL } from "@/lib/constants";

const CONTENT = {
  "aviso-legal": {
    title: "Aviso legal",
    testid: "legal-aviso-legal",
    sections: [
      {
        h: "Titular de la web",
        p: "Nidoria es un portal inmobiliario de pisos y casas en alquiler y venta en toda España. Para cualquier consulta sobre esta web puedes escribirnos por WhatsApp al " + WHATSAPP_PHONE_DISPLAY + " o al correo hola@nidoria.es.",
      },
      {
        h: "Objeto",
        p: "Esta web informa sobre la aplicación móvil de Nidoria y sobre los inmuebles que nuestro equipo busca, revisa y publica. El acceso a la web es libre y no requiere registro de usuarios.",
      },
      {
        h: "Propiedad intelectual",
        p: "Todos los contenidos de esta web (textos, diseño, logotipos e imágenes) pertenecen a Nidoria o se utilizan con licencia. No está permitida su reproducción sin autorización expresa.",
      },
      {
        h: "Responsabilidad",
        p: "La información de los inmuebles se publica de buena fe y se revisa antes de cada publicación. Nidoria no pide dinero ni documentación por adelantado en ningún caso: toda la gestión se realiza en persona. Si alguien te pide pagos en nuestro nombre, escríbenos antes de hacer nada.",
      },
    ],
  },
  privacidad: {
    title: "Política de privacidad",
    testid: "legal-privacidad",
    sections: [
      {
        h: "Responsable del tratamiento",
        p: "El responsable del tratamiento de los datos es Nidoria. Puedes contactar con nosotros por WhatsApp al " + WHATSAPP_PHONE_DISPLAY + " o en hola@nidoria.es.",
      },
      {
        h: "Qué datos recogemos",
        p: "Esta web no tiene registro de usuarios ni formularios de contacto, por lo que no recogemos datos personales a través de ella. Si nos escribes por WhatsApp, trataremos tu número y tu mensaje únicamente para responderte y gestionar tu consulta sobre inmuebles.",
      },
      {
        h: "Base jurídica y conservación",
        p: "La base del tratamiento es tu consentimiento al escribirnos y el interés legítimo en responder tu consulta. Conservamos las conversaciones solo el tiempo necesario para atender tu solicitud.",
      },
      {
        h: "Tus derechos",
        p: "Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiéndonos a hola@nidoria.es. También puedes reclamar ante la Agencia Española de Protección de Datos (aepd.es).",
      },
    ],
  },
  cookies: {
    title: "Política de cookies",
    testid: "legal-cookies",
    sections: [
      {
        h: "Qué son las cookies",
        p: "Las cookies son pequeños archivos que se guardan en tu dispositivo al visitar una web y que permiten recordar información sobre tu visita.",
      },
      {
        h: "Cookies que utilizamos",
        p: "En Nidoria usamos cookies técnicas imprescindibles para el funcionamiento de la web (por ejemplo, recordar tu elección en el aviso de cookies) y, solo si las aceptas, cookies de análisis para entender cómo se usa la página y mejorarla.",
      },
      {
        h: "Cómo aceptar, rechazar o cambiar tu decisión",
        p: "Al entrar en la web verás un aviso con los botones Aceptar y Rechazar. Tu elección se guarda en tu navegador. Para cambiarla, borra los datos de navegación de este sitio y vuelve a entrar: el aviso aparecerá de nuevo. También puedes configurar tu navegador para bloquear o eliminar cookies.",
      },
      {
        h: "Más información",
        p: "Si tienes dudas sobre nuestra política de cookies, escríbenos por WhatsApp al " + WHATSAPP_PHONE_DISPLAY + " o a hola@nidoria.es.",
      },
    ],
  },
};

export default function LegalPage({ page }) {
  const content = CONTENT[page] || CONTENT["aviso-legal"];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <div data-testid={content.testid}>
      <Header />
      <main className="min-h-screen bg-[#f7f4ee] pb-24 pt-28 dark:bg-[#0c1a29] sm:pt-32">
        <div className="mx-auto max-w-3xl px-4 sm:px-6">
          <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-[#0f766e] dark:text-[#14b8a6]">Nidoria · Legal</p>
          <h1 className="mt-3 font-serif text-4xl font-semibold text-[#12263a] dark:text-[#f7f4ee] sm:text-5xl">
            {content.title}
          </h1>
          <p className="mt-3 text-xs font-semibold text-[#12263a]/45 dark:text-[#f7f4ee]/40">
            Última actualización: julio de 2026
          </p>

          <div className="mt-10 space-y-8">
            {content.sections.map((section) => (
              <section key={section.h} className="rounded-3xl border border-[#12263a]/10 bg-white p-6 dark:border-white/10 dark:bg-[#102336] sm:p-8">
                <h2 className="font-serif text-xl font-semibold text-[#12263a] dark:text-[#f7f4ee]">{section.h}</h2>
                <p className="mt-3 text-sm leading-relaxed text-[#12263a]/65 dark:text-[#f7f4ee]/60">{section.p}</p>
              </section>
            ))}
          </div>

          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-2 text-sm font-bold text-[#0f766e] underline decoration-[#14b8a6] underline-offset-4 dark:text-[#14b8a6]"
            data-testid="legal-whatsapp-link"
          >
            ¿Dudas? Escríbenos por WhatsApp
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}
